import { useEffect, useState } from 'react';
import { Card, CardBody, Input } from 'reactstrap';

const CustomFilterCard = ({ visible, onClose, filterKey, filterValue, onChange, options = [] }) => {
  const [inputValue, setInputValue] = useState('');

  useEffect(() => {
    if (visible) {
      setInputValue('');
    }
  }, [visible]);

  const filteredOptions = options.filter(option => option?.toLowerCase()?.startsWith(inputValue.toLowerCase()));

  if (!visible) return null;

  return (
    <Card style={{ position: 'absolute', top: '100%', zIndex: 999, width: '300px' }}>
      <CardBody>
        <Input type="text" value={inputValue} onChange={e => setInputValue(e.target.value)} placeholder={`Search ${filterKey}`} className="mb-2" />
        <div style={{ maxHeight: '150px', overflowY: 'scroll', whiteSpace: 'nowrap', textOverflow: 'ellipsis' }}>
          {filteredOptions.map((option, idx) => (
            <div
              key={idx}
              onClick={() => {
                onChange(filterKey, option); // apply selected filter
                onClose(); // close dropdown after selection
              }}
              className="px-3 pt-2 pb-2 hover:bg-light"
              style={{ cursor: 'pointer', borderBottom: '1px solid #eee' }}
            >
              {option}
            </div>
          ))}
          {filteredOptions.length === 0 && <div className="text-muted px-2">No match found</div>}
        </div>
        <div className="d-flex justify-content-end mt-2">
          <button onClick={onClose} className="btn btn-sm btn-outline-secondary">
            Close
          </button>
        </div>
      </CardBody>
    </Card>
  );
};

export default CustomFilterCard;
